<template>
    <div class="products woocommerce">
        <h3>Scegli i tuoi piatti preferiti</h3>
        <p>Seleziona i piatti che vuoi ricevere. Potrai cambiarli in seguito durante l’abbonamento</p>
        
        <div v-if="productsNotEnough" class="woocommerce-error mb-6">
            <ul class="msg">
                <li>
                    <span class="status_msg">
                        Non ci sono abbastanza piatti per completare l'abbonamento, torna indietro per cambiare obiettivi e/o allergeni.<br>
                        Oppure contatta i nostri nutrizionisti per trovare la soluzione migliore pe te.
                    </span>
                </li>

            </ul>
        </div>
    
        <div v-if="(pastiLeft !== 0 && active == 'pasto') || (colLeft !== 0 && active == 'colazione') && !productsNotEnough" class="woocommerce-info">
            <ul class="msg">
                <li v-if="colLeft !== 0 && active == 'colazione'">
                    <span class="status_msg">
                        <span class="bundled_items_selection_msg">Completa il menu con ancora {{ colLeft }} colazione/i</span><span class="bundled_items_selection_status">{{ productsSelectedNumber }} elementi selezionati</span>
                    </span>
                </li>
                <li v-if="pastiLeft !== 0 && active == 'pasto'">
                    <span class="status_msg">
                        <span class="bundled_items_selection_msg">Completa il menu con ancora {{ pastiLeft }} pasto/i</span><span class="bundled_items_selection_status">{{ productsSelectedNumber }} elementi selezionati</span>
                    </span>
                </li>
            </ul>
        </div>

        <ul id="tipo-menu" class="nav nav-underline justify-content-center py-4" v-if="!productsNotEnough">
            <li class="nav-item" v-if="colazioni.length">
                <a class="nav-link link-body-emphasis active" data-tipo="colazione" @click="setActive('colazione')" href="#">Colazione</a>
            </li>
            <li class="nav-item" v-if="pasti.length">
                <a class="nav-link link-body-emphasis" data-tipo="pasto" @click="setActive('pasto')" href="#">Pasto</a>
            </li>
        </ul>
        
        <div v-if="active == 'colazione' && !productsNotEnough" class="colazione">
            <table class="bundled_products" cellspacing="0">
                <product-sheet v-for="(colazione, c) in colazioni" :max="colmandatory" :ref="'colel_' + c" :prod="colazione" :key="'colaz_' + c" @update="updCart"  />
            </table>
        </div>
        
        <div v-if="active == 'pasto' && !productsNotEnough" class="pasto">
            <table class="bundled_products" cellspacing="0">
                <product-sheet v-for="(pasto, p) in pasti"  :max="pastimandatory" :ref="'pasel_' + p" :prod="pasto" :key="'past_' + p" @update="updCart" />
            </table>
        </div>

        <div class="d-flex justify-content-center justify-content-md-start position-sticky bottom-0 py-3 bg-dark-subtle">
            <button class="steplink stepback btn btn-secondary me-2" @click="backStep">Indietro</button>
            <button class="steplink stepnext btn btn-primary" :disabled="canGoNext"
                @click="nextStep">Continua</button>
        </div>
        
        <loader v-if="loading" />

    </div>
</template>

<script>
import Loader from '@/components/Loader';
import ProductSheet from '@/components/parts/ProductSheet';
import { getData } from "@/api/ajax";
import { union, isNil , isEmpty } from "lodash";

export default {
    name: 'ProductsStep',
    mixins: [getData],
    data() {
        return {
            loading: false,
            errorLoading: false,
            colazioni: [],
            pasti: [],
            active: 'colazione',
            selected: this.$store.state.abbonamento.products,
            obiettivi: this.$store.state.abbonamento.obiettivi,
            allergeni: this.$store.state.abbonamento.allergeni,
            productsNotEnough: false,
            masterProducts: null
        }
    },
    props: {
        direction: String
    },
    computed: {
        colazioniSelected(){
            return this.selected.filter(product => product.tipo == 'colazione');
        },
        pastiSelected() {
            return this.selected.filter(product => product.tipo == 'pasto');
        },
        colazioniSelectedNumber() {
            if(this.colazioniSelected.length>0)
                return this.colazioniSelected.map(i => i.quantity).reduce((a, b) => parseInt(a) + parseInt(b));
            else
                return 0;
        },
        pastiSelectedNumber() {
            if(this.pastiSelected.length>0)
                return this.pastiSelected.map(i => i.quantity).reduce((a, b) => parseInt(a) + parseInt(b));
            else
                return 0;
        },
        productsSelectedNumber() {
            if (this.selected.length > 0)
                return this.selected.map(i => i.quantity).reduce((a, b) => parseInt(a) + parseInt(b));
            else
                return 0;
        },
        canGoNext() {
            if(this.colLeft == 0 && this.pastiLeft == 0)
                return false;
            else
                return true;
        },
        products() {
            return this.colazioni.concat(this.pasti);
        },
        lenghtStoreProducts() {
            return this.$store.getters.getNumberOfProducts;
        },
        ndays() {
            const variations = this.$store.state.variations;
            const variation = this.$store.state.abbonamento.variation;

            let varobj = variations.filter(varo => varo.id == variation);

            if(varobj.length > 0){
                return varobj[0].piano.split('-');
            }else{
                return ['half',5];
            }
        },
        colmandatory() {
            return parseInt(this.ndays[1]);
        },
        pastimandatory() {
            const days = parseInt(this.ndays[1]);
            const timeDay = this.ndays[0] == 'half' ? 1 : 2;
            return parseInt(days * timeDay);
        },
        colLeft() {
            return parseInt(this.colmandatory) - parseInt(this.colazioniSelectedNumber);
        },
        pastiLeft() {
            return parseInt(this.pastimandatory) - parseInt(this.pastiSelectedNumber);
        }
    },
    components: {
        Loader,
        ProductSheet
    },
    async beforeMount() {
        // se provengo da step precedente o non ci sono prodotti in store li carico
        if( this.direction == 'nextstep' || this.lenghtStoreProducts == 0 ){
            this.loading = true;
            try {
                // carico da chiamata ajax
                const products = await this.getProducts(this.obiettivi, this.allergeni, this.ndays);
                this.log('loaded products divisi', products.data);
                this.masterProducts = products.data;
                // assengo tipo prodotti con dati appena scaricati
                this.colazioni = products.data.colazioni;
                this.pasti = products.data.pasti;
                // this.products a questo punto sarà valorizzata con merge dei tipi prodotto            
                this.loading = false;
            } catch (e) {
                this.loading = false;
                this.errorLoading = true;
                this.log(e);
            }
        }
        // se c'è errore di caricamento e ci sono prodotti in store
        // oppure
        // non c'è errore di caricamento e si proviene da step successivo
        if ( this.errorLoading && this.$store.getters.products || !this.errorLoading && this.direction == 'prevstep' && this.$store.getters.products ) {
            this.masterProducts = this.$store.getters.products;
            this.colazioni = this.masterProducts.colazioni;
            this.pasti = this.masterProducts.pasti;
        }
        
        // imposto store products master se ci sono prodotti
        if( !isNil(this.masterProducts) ){
            this.$store.commit('setProducts', this.masterProducts );
            this.log('salvo il nuovo master prodotti');
        }
        
        // se caricamento fallisce e non ho prodotti store stoppo il processo
        if( this.errorLoading && !isNil(this.masterProducts) || isEmpty(this.selected) )
            return;

        this.log('selected', this.selected.filter((select) => select.id));
        this.log('products', this.products.filter((product) => product.ID));
        const newSelected = [];
        this.products.forEach((prod) => {
            const index = this.selected.findIndex(t => t.id == prod.ID);
            this.log('index prods', prod.ID,index);
            // se non è presente nel master lo rimuovo dal select
            if (index >= 0)
                newSelected.push(this.selected[index]);
        });
        this.selected = newSelected;
        this.log('number of selected prods', this.selected.length)
        await this.$nextTick();
        
        // prendo prodotti precedentemente salvati nello store
        // const oldProducts = this.$store.getters.products;
        // this.log('primo caricamento?',isNil(oldProducts));
            

        this.products.forEach((prodotto) => {
            if(prodotto.image){
                const image = new Image();
                image.loading = "lazy";
                image.src = prodotto.image;
            }
        });
    },
    mounted() {
        this.GTM_trackView("Step scelta piatti", "/abbonamento#step4");
    },
    methods: {
        setActive(tipo){
            this.active = tipo;
        },
        backStep() {
            this.$emit("update", {
                back: true
            });
            return;
        },
        nextStep() {
            this.$store.commit("setStore", { products: this.selected });
            this.$emit("update", {
                next: true
            });
        },
        updCart: async function (product){
            const index = this.selected.findIndex(t => t.id == product.id)
            // const tmpP = this.allergeni[i];
            // this.log('updcart', product, index);
            
            // se rimosso quantity ed è presente nel carrello
            if(product.quantity < 1 && index >= 0){
                // pull(this.selected, index);
                this.selected.splice(index, 1);
                this.log('dovrebbe rimuovere', this.selected);
            }else{
                // se quantity è presente
                if (product.quantity > 0 && index < 0)
                    this.selected = union([product], this.selected);
                else if(product.quantity > 0 && index >= 0)
                    this.selected[index].quantity = product.quantity
            }
            await this.$nextTick();
        }
    },
    watch: {
        selected: {
            handler(val) {
                this.$store.commit('setStore', { products: val });
                this.log('products_active',this.$store.getters.products_active);
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
ul.msg{
    margin-bottom: 0;
}
#tipo-menu{
    a{
        padding: 0 2rem 1rem 2rem;
        display: block;
        text-align: center;
        font-weight: 400;
        border-bottom: var(--bs-nav-underline-border-width) solid rgba(255, 255, 255, 0.3);
        &.active {
            border-top: 0 !important;
            border-left: 0 !important;
            border-right: 0 !important;
            border-color: #fff !important;
        }
    }
}
.products {
    table{
        width: 100%;
    }
    .bundled_items_selection_status{
        float: right;
    }
}
</style>